import { call, put, all, takeEvery, select } from "redux-saga/effects";

import { newsActions } from '../slice/newsSlice'
import { getAllByAdminApi, createApi, updateApi, deleteApi, getNewsByCategoryApi, getNewsDetailApi } from 'services/newsServices'
import { newsSelector } from "redux/selector"


function* handleGetNews(action) {
    try {
        const res = yield call(getAllByAdminApi, action.payload.query, action.payload.category, action.payload.currentPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsActions.getNewsSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(newsActions.getNewsFailed())
            }
        }
        else {
            yield put(newsActions.getNewsFailed())
        }
    } catch (error) {
        yield put(newsActions.getNewsFailed())
    }
}

function* handleGetNewsByCategory(action) {
    try {
        const res = yield call(getNewsByCategoryApi, action.payload.slug, action.payload.currentPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsActions.getNewsByCategorySuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(newsActions.getNewsByCategoryFailed())
            }
        }
        else {
            yield put(newsActions.getNewsByCategoryFailed())
        }
    } catch (error) {
        yield put(newsActions.getNewsByCategoryFailed())
    }
}



function* handleGetNewsDetail(action) {
    try {
        const res = yield call(getNewsDetailApi, action.payload.slug)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsActions.getNewsDetailSuccess({ data: response.data }))
            }
            else {
                yield put(newsActions.getNewsDetailFailed())
            }
        }
        else {
            yield put(newsActions.getNewsDetailFailed())
        }
    } catch (error) {
        yield put(newsActions.getNewsDetailFailed())
    }
}


function* handleCreateNews(action) {
    try {
        const res = yield call(createApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsActions.addNewsSuccess())
                action.payload.ShowToast('success', 'Thêm bài viết thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(newsActions.getNews({ query: action.payload.querySearch, category: action.payload.selectedCategory, currentPage: action.payload.currentPage }))
            } else {
                yield put(newsActions.addNewsFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Thêm bài viết thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(newsActions.addNewsFailed())
            action.payload.ShowToast('error', 'Thêm bài viết thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(newsActions.addNewsFailed())
        action.payload.ShowToast('error', 'Thêm bài viết thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateNews(action) {
    try {
        const res = yield call(updateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsActions.updateNewsSuccess())
                action.payload.ShowToast('success', 'Cập nhật bài viết thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(newsActions.getNews({ query: action.payload.querySearch, category: action.payload.selectedCategory, currentPage: action.payload.currentPage }))

            } else {
                yield put(newsActions.updateNewsFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Cập nhật bài viết thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(newsActions.updateNewsFailed())
            action.payload.ShowToast('error', 'Cập nhật bài viết thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(newsActions.updateNewsFailed())
        action.payload.ShowToast('error', 'Cập nhật bài viết thất bại, vui lòng thử lại sau!')
    }
}



function* handleRemoveNews(action) {
    try {
        const res = yield call(deleteApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(newsActions.removeNewsSuccess())
                const newsState = yield select(newsSelector)
                let totalPage = newsState.totalPage
                if (newsState.newsList.length === 1) {
                    totalPage = totalPage - 1
                    yield put(newsActions.setTotalPage(totalPage))
                    action.payload.setCurrentPage(action.payload.currentPage - 1)
                    yield History.navigate(`/admin/news?page=${action.payload.currentPage - 1}`);
                }
                action.payload.ShowToast("success", 'Xóa bài viết thành công!')
                yield put(newsActions.getNews({ query: action.payload.querySearch, category: action.payload.selectedCategory, currentPage: action.payload.currentPage }))
            } else {
                yield put(newsActions.removeNewsFailed())
                action.payload.ShowToast('error', `${response.data[1]}`)
                action.payload.ShowToast('error', `Xóa bài viết thất bại, bài viết đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
            }
        }
        else {
            yield put(newsActions.removeNewsFailed())
            action.payload.ShowToast('error', `Xóa bài viết thất bại, bài viết đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
        }
    } catch (error) {
        yield put(newsActions.removeNewsFailed())
        action.payload.ShowToast('error', `Xóa bài viết thất bại, bài viết đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
    }
}


export default function* newsSaga() {
    yield all(
        [
            takeEvery(newsActions.getNews.type, handleGetNews),
            takeEvery(newsActions.getNewsByCategory.type, handleGetNewsByCategory),
            takeEvery(newsActions.addNews.type, handleCreateNews),
            takeEvery(newsActions.updateNews.type, handleUpdateNews),
            takeEvery(newsActions.removeNews.type, handleRemoveNews),
            takeEvery(newsActions.getNewsDetail.type, handleGetNewsDetail),
        ]
    )
}
